<template>
    <div class="animated fadeIn">
        <filter-form
                :voorspellingsplaatsen="voorspellingsplaatsen"
                :currentFilter="currentFilter"
                @get-forecast-data="getForecastData">
        </filter-form>

        <div class="row">
            <div class="col-sm-12">
                <transition name="fade">
                    <b-card v-if="showgrafiek">
                        <div class="row">
                            <div class="col-sm-5">
                                <h4 class="card-title mb-0">{{voorspellingsplaatstekst}}</h4>
                                <div class="small text-muted">{{intervaltekst}}</div>
                            </div><!--/.col-->
                        </div><!--/.row-->
                        <div v-if="(transitionFilter.periode == -1)" style="height:300px;margin-top:40px;"></div>
                        <br />
                        <span class="small text-muted">mol/m<sup>2</sup></span>
                        <linechart v-if="(transitionFilter.periode == 0 || transitionFilter.periode == 1)" :chart-data="datacollection" class="chart-wrapper" style="height:300px;margin-top:40px;"></linechart>
                        <barchart v-if="(transitionFilter.periode == 2)" :chart-data="datacollection" class="chart-wrapper" style="height:300px;margin-top:40px;"></barchart>
                    </b-card>
                </transition>
            </div><!--/.col-->
        </div><!--/.row-->
    </div>
</template>

<script>
    import datefunctions from '../../helpers/datefunctions';
    import apiplaats from '../../api/voorspellingsplaats';
    import apivoorspelling from '../../api/voorspelling';
    import FilterForm from './FilterFormVoorspelling';
    import LineChart from './LineChartR0';
    import BarChart from './BarChart';

    export default {
        data () {
            return {
                showgrafiek: false,
                voorspellingsplaatsen: [],
                vandaag: '2018-01-01',
                currentFilter: {
                    voorspellingsplaats: 1,
                    periode: 0,
                },
                chartFilter: {
                    voorspellingsplaats: '',
                    periode: -1,
                },
                transitionFilter: {
                    periode: -1,
                },
                datacollection: {
                    labels: [''],
                    datasets: [
                        {
                            label: '',
                            data: [10],
                        },
                    ],
                },
            };
        },
        computed: {
            intervaltekst () {
                switch (this.chartFilter.periode) {
                case 0:
                    return `vandaag (${datefunctions.datetoDDMMYYYY(this.vandaag)})`;
                case 1:
                    return `morgen (${datefunctions.datetoDDMMYYYY(this.vandaag)})`;
                case 2:
                    return '+5 dagen';
                default:
                    return '';
                }
            },
            voorspellingsplaatstekst () {
                return this.voorspellingsplaatsen.find(v => v.id ===
                    this.chartFilter.voorspellingsplaats).plaats;
            },
        },
        created () {
            apiplaats.getAllVoorspellingsplaats().then((response) => {
                this.voorspellingsplaatsen = response.data;
                this.currentFilter.voorspellingsplaats = this.voorspellingsplaatsen[0].id;
            });
        },
        methods: {
            getForecastData () {
                if (this.chartFilter.periode !== this.currentFilter.periode) {
                    this.transitionFilter.periode = -1;
                }
                this.chartFilter.voorspellingsplaats = this.currentFilter.voorspellingsplaats;
                this.chartFilter.periode = this.currentFilter.periode;

                switch (this.chartFilter.periode) {
                case 0:
                case 1:
                    apivoorspelling.getDetailvoorspelling(
                        this.chartFilter.voorspellingsplaats, this.chartFilter.periode)
                        .then((response) => {
                            if (response.data.length !== 0) {
                                this.vandaag = response.data[0].datum;
                            }
                            this.showgrafiek = true;
                            const labels = [];
                            const data = [];
                            this.formatdetailresults(response.data, labels, data);
                            this.fillData(this.voorspellingsplaatstekst, labels, data);
                            this.transitionFilter.periode = this.chartFilter.periode;
                        });
                    break;
                case 2:
                    apivoorspelling.getDagvoorspelling(
                        this.chartFilter.voorspellingsplaats).then((response) => {
                        this.showgrafiek = true;
                        const labels = [];
                        const data = [];
                        this.formatdayresults(response.data, labels, data);
                        this.fillData(this.voorspellingsplaatstekst, labels, data);
                        this.transitionFilter.periode = this.chartFilter.periode;
                    });
                    break;
                default:
                    break;
                }
            },
            fillData (label, labels, data) {
                this.datacollection = {
                    labels,
                    datasets: [
                        {
                            label: 'Zonlicht',
                            backgroundColor: 'rgba(0, 204, 204, 0.2)',
                            borderColor: 'rgba(0, 204, 204, 1)',
                            pointHoverBackgroundColor: '#fff',
                            borderWidth: 2,
                            data,
                        },
                    ],
                };
            },
            formatdetailresults (reponsedata, labels, data) {
                reponsedata.forEach((rdata) => {
                    labels.push(rdata.label.substring(0, 5));
                    data.push(rdata.waarde);
                });
            },
            formatdayresults (reponsedata, labels, data) {
                reponsedata.forEach((rdata) => {
                    labels.push([datefunctions.stringdagVoluit(rdata.label),
                        datefunctions.datetoDDMMYYYY(rdata.label)]);
                    data.push(rdata.waarde);
                });
            },
        },
        components: {
            'filter-form': FilterForm,
            linechart: LineChart,
            barchart: BarChart,
        },
    };
</script>

<style>
.fade-enter-active, .fade-leave-active {
transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
opacity: 0
}
</style>



// WEBPACK FOOTER //
// src/pages/weer/Voorspelling.vue